import { useContext } from 'react'
import { Summary, Currency } from 'shared/components'
import { useTranslation } from 'libs/i18n'
import { DashboardContext } from 'store'
import {
	BanknotesIcon,
	CircleStackIcon,
	CubeIcon,
	CurrencyDollarIcon,
	DocumentTextIcon,
	ReceiptPercentIcon,
	WalletIcon
} from '@heroicons/react/24/outline'
import { SalesSummary } from 'features/sales/types/sales.types'
import { Price } from 'shared/types/general.types'

export const SummarySection = ({ summary }: { summary: SalesSummary | undefined }) => {
	const { t } = useTranslation()
	const dashboardCtx = useContext(DashboardContext)
	const dashboard = dashboardCtx?.dashboard

	if (!summary) return null

	const currency = summary.total.currency
	const money = (price: Price | undefined) => (
		<Currency price={{ amount: price?.amount ?? 0, currency: price?.currency ?? currency }} />
	)

	return (
		<div className="grid gap-3 sm:grid-cols-[repeat(2,1fr)] lg:grid-cols-[repeat(4,1fr)]">
			<Summary
				compact
				title={t('Balance')}
				content={
					<Currency
						price={{
							amount: dashboard?.balance ?? 0,
							currency: dashboard?.currency ?? currency
						}}
					/>
				}
				icon={<WalletIcon />}
				iconBgColor="bg-success-soft"
				iconColor="text-success"
			/>
			<Summary
				compact
				title={t('Quantity')}
				content={new Intl.NumberFormat().format(summary.total_quantity ?? 0)}
				icon={<CubeIcon />}
			/>
			<Summary
				compact
				title={t('Subtotal')}
				content={money(summary.subtotal)}
				icon={<DocumentTextIcon />}
			/>
			<Summary
				compact
				title={t('Discount')}
				content={money(summary.discount)}
				icon={<ReceiptPercentIcon />}
				iconBgColor="bg-warning-soft"
				iconColor="text-warning"
			/>
			<Summary
				compact
				title={t('Total')}
				content={money(summary.total)}
				icon={<CurrencyDollarIcon />}
				iconBgColor="bg-danger-soft"
				iconColor="text-danger"
			/>
			<Summary
				compact
				title={t('Commission')}
				content={money(summary.commission)}
				icon={<CircleStackIcon />}
			/>
			<Summary
				compact
				title={t('Remaining')}
				content={money(summary.to_payout)}
				icon={<BanknotesIcon />}
				iconBgColor="bg-success-soft"
				iconColor="text-success"
			/>
		</div>
	)
}
